import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DtpAccordionPanel, DtpAccordionGroup } from 'dtp-react-components';
import { Input, Grid, Button } from '../../components';
import { tipoEntidade } from '../../utils/listsSelect';
import { trataMensagensErro, requestSalvaFiltroBloqueio } from '../../utils/requests';

class FiltroBloqueioDesbloqueio extends Component {
  constructor() {
    super();
    this.filtroBloqueio = JSON.parse(sessionStorage.getItem('filtroBloqueio'));

    this.state = {
      'destinatario-rpps':
      this.filtroBloqueio && this.filtroBloqueio['destinatario-rpps'] ?
        this.filtroBloqueio['destinatario-rpps'] : null,
      cliqueiNoBotao:
        this.filtroBloqueio && this.filtroBloqueio.cliqueiNoBotao ?
          this.filtroBloqueio.cliqueiNoBotao : null,
      tipoEntidade:
      this.filtroBloqueio && this.filtroBloqueio.tipoEntidade ?
        this.filtroBloqueio.tipoEntidade : null,
      uf:
      this.filtroBloqueio && this.filtroBloqueio.uf ?
        this.filtroBloqueio.uf : null,
      competenciaAberta:
      this.filtroBloqueio && this.filtroBloqueio.competenciaAberta ?
        this.filtroBloqueio.competenciaAberta : null,
      tipoFiltroBloqueio:
        this.filtroBloqueio && this.filtroBloqueio.tipoFiltroBloqueio ?
          this.filtroBloqueio.tipoFiltroBloqueio : null,
    };
  }

  componentDidMount() {
    this.preparaNovaConsulta();
    // if (sessionStorage.getItem('filtroBloqueio')) {
    //   this.handleSearchButton();
    // }
    // this.buscaCompetenciaPagamentoAberta();
  }

  componentDidUpdate(prevProps) {
    // Apenas repete consulta se parametro da url for alterado
    if (this.props.tipoConsulta !== prevProps.tipoConsulta) {
      this.preparaNovaConsulta();
    }
  }

  controleFiltrosAlternativos = (campo) => {
    switch (campo) {
      case 'destinatario-rpps':
        return ['gerenciar-negocio-dcomp', 'analisar-negocio-sprev', 'analisar-contrato-dtpv'];
      default:
        return [];
    }
  }

  preparaNovaConsulta = () => {
    let filtroBloqueio = {
      'destinatario-rpps': null,
      tipoEntidade: null,
      uf: null,
    };

    filtroBloqueio = JSON.stringify(filtroBloqueio);
    sessionStorage.setItem('filtroBloqueio', filtroBloqueio);

    this.setState({
      'destinatario-rpps': null,
      tipoEntidade: null,
      uf: null,
    });
  }

  handleChange = (changeObj, name) => {
    this.setState({
      [name]: changeObj.value,
    }, () => this.trataFormulario(name));
  }

  /**
   * Encaminha para as funcoes que tratam alteracoes em cada campo
   */
  trataFormulario = (campoAlterado) => {
    if (campoAlterado === 'tipoEntidade') {
      this.trataTipoEntidade();
    }
    if (campoAlterado === 'uf') {
      this.trataUf();
    }
    if (campoAlterado === 'destinatario-rpps') {
      let filtroBloqueio = {
        'destinatario-rpps': this.state['destinatario-rpps'],
        tipoEntidade: this.state.tipoEntidade,
        uf: this.state.uf,
        competenciaAberta: this.props.competenciaAberta,
      };
      filtroBloqueio = JSON.stringify(filtroBloqueio);
      requestSalvaFiltroBloqueio(filtroBloqueio);
    }
  }

  trataUf = () => {
    this.setState({ 'destinatario-rpps': null });
  }

  trataCombosEntidade = () => {
    this.setState({ tipoEntidade: null, 'destinatario-rpps': null, uf: null });
  }

  trataTipoEntidade = () => {
    this.setState({ 'destinatario-rpps': null, uf: null });
  }

  handleSearchButton = () => {
    let filtroBloqueio = {
      'destinatario-rpps': this.state['destinatario-rpps'],
      tipoEntidade: this.state.tipoEntidade,
      uf: this.state.uf,
      competenciaAberta: this.props.competenciaAberta,

    };
    filtroBloqueio = JSON.stringify(filtroBloqueio);
    sessionStorage.setItem('filtroBloqueio', filtroBloqueio);
    this.setState(
      {
        cliqueiNoBotao: 1,
      },
      () => {
        this.handleChange({
          value: 1,
          isValid: true,
        }, 'cliqueiNoBotao');
      },
    );
    this.handleSearch();
  }

  handleSearch = () => {
    if (this.props.competenciaAberta != null) {
      this.state.competenciaAberta = this.props.competenciaAberta;
    }

    if (!this.props.existeCompetenciaInicial) {
      trataMensagensErro(['Não existe competência de pagamento aberta.']);
    } else if (this.state.tipoEntidade && this.props.existeCompetenciaInicial) {
      if (this.state.tipoEntidade === 2 && !this.state.uf && !this.state['destinatario-rpps']) {
        trataMensagensErro(['Escolha uma UF']);
        return;
      }
      if (this.state.tipoEntidade && !this.state['destinatario-rpps']) {
        trataMensagensErro(['Escolha um filtro de destinatário para a consulta']);
        return;
      }
      if (this.state.tipoEntidade && this.state.uf && !this.state['destinatario-rpps']) {
        trataMensagensErro(['Escolha um filtro de destinatário para a consulta']);
        return;
      }
      this.props.handleSearchFilter(this.state);
    } else if (!this.state.tipoEntidade && this.props.existeCompetenciaInicial) {
      this.props.handleSearchFilter(this.state);
    } else {
      trataMensagensErro(['Escolha pelo menos um filtro de Ente federativo para a consulta.']);
    }
  }

  listaFiltradaDestinatarios = () => {
    const listaParticipantes = this.props.destinatarios.filter((item) => {
      if (item.tipoRegimeProprio === this.state.tipoEntidade &&
        ((item.uf && this.state.tipoEntidade === 2) ? item.uf === this.state.uf : true)) {
        return item;
      }
      return null;
    });
    return listaParticipantes;
  }

  carregaUfDosMunicipios = () => {
    const listaUf = [];
    this.props.destinatarios.forEach((item) => {
      if (item.uf && !listaUf.find(itemLista => itemLista.value === item.uf)) {
        listaUf.push({
          label: item.uf,
          value: item.uf,
        });
      }
    });
    listaUf.sort((a, b) => {
      if (a.value > b.value) {
        return 1;
      }
      if (a.value < b.value) {
        return -1;
      }
      return 0;
    });
    return listaUf;
  }

  handleChangeTipoFiltro = (changeObj, name) => {
    this.setState({
      [name]: changeObj.value,
    }, () => this.trataFormulario(name));
  }

  verificaSeCampoDesabilitado = () => {
    if (this.props.existeCompetenciaInicial === false) {
      return true;
    }
    return false;
  };

  montaFiltrosDefault = () => (
    <React.Fragment>
      <div className="row">
        <Grid cols="1 1 1 1">
          <Input
            label="Competência"
            onChange={e => this.handleChange(e, 'competenciaAberta')}
            value={this.props.competenciaAberta}
            disabled
          />
        </Grid>
        <Grid cols="3 3 3 3">
          <Input
            disabled={this.verificaSeCampoDesabilitado()}
            label="Tipo"
            onChange={e => this.handleChange(e, 'tipoEntidade')}
            placeholder="Selecione a entidade"
            value={this.state.tipoEntidade}
            itemList={tipoEntidade}
            custom
            number
          />
        </Grid>
        {this.state.tipoEntidade === 2 ? (
          <Grid cols="3 3 3 3">
            <Input
              label="UF"
              onChange={e => this.handleChange(e, 'uf')}
              placeholder="Selecione a UF"
              value={this.state.uf}
              itemList={this.carregaUfDosMunicipios()}
              custom
            />
          </Grid>
        ) : ''}
        {this.state.tipoEntidade ? (
          <Grid cols="4 4 4 4">
            <Input
              label="Nome"
              name="destinatario-rpps"
              onChange={e => this.handleChange(e, 'destinatario-rpps')}
              placeholder="Selecione o destinatário"
              value={this.state['destinatario-rpps']}
              itemList={this.listaFiltradaDestinatarios()}
              custom
            />
          </Grid>
        ) : ''}
      </div>
    </React.Fragment>
  )

  montaFiltros = () => {
    if (this.props.tipoConsulta) {
      return this.montaFiltrosDefault();
    }
    return null;
  }

  render() {
    const filtrosPesquisa = this.montaFiltros();
    if (!filtrosPesquisa) {
      return null;
    }
    return (
      <DtpAccordionGroup>
        <DtpAccordionPanel
          headingId="pesquisa"
          panelId="filtro-pesquisa"
          icon="ico-filter"
          title="Filtro de Pesquisa"
        >
          {filtrosPesquisa}
          <div className="row">
            <Button
              disabled={this.verificaSeCampoDesabilitado()}
              className="dtp-primary right"
              title="Pesquisar"
              onClick={() => this.handleSearchButton()}
              hint="Pesquisar de acordo com o filtro aplicado"
            />
          </div>
        </DtpAccordionPanel>
      </DtpAccordionGroup>
    );
  }
}

FiltroBloqueioDesbloqueio.propTypes = {
  destinatarios: PropTypes.arrayOf().isRequired,
  handleChangeList: PropTypes.func,
  handleSearchFilter: PropTypes.func,
  list: PropTypes.array,
  tipoConsulta: PropTypes.string,
  existeCompetenciaInicial: PropTypes.bool,
  competenciaAberta: PropTypes.string,
}.isRequired;

export default FiltroBloqueioDesbloqueio;



// WEBPACK FOOTER //
// ./src/pages/consultas/FiltroBloqueioDesbloqueio.jsx